import { Outlet } from 'react-router-dom'
import { useCallback } from 'react'
import { useSetRecoilState } from 'recoil'

import { resetAuthState } from 'services/auth'
import { Navbar } from 'components/Navbar/Navbar'

import './panel.style.css'

export const Panel = () => {
  const resetAuth = useSetRecoilState(resetAuthState)

  const handleOnClick = useCallback(() => {
    resetAuth()
  }, [resetAuth])

  const renderHeader = useCallback(() => {
    if (window.location.pathname.startsWith('/v2')) {
      return null
    }

    return (
      <>
        <div className="panel__btn-exit">
          <Navbar />
        </div>
        <div className="panel__btn-exit">
          <button className="btn btn-primary" onClick={handleOnClick}>
            Выход
          </button>
        </div>
      </>
    )
  }, [handleOnClick])

  return (
    // TODO: Сделать анимацию вправо-влево по переходам между экранами.
    <div className="panel__boundary">
      <div className="panel__header">{renderHeader()}</div>
      <div className="panel__content">
        <div className="panel__content-center">
          <Outlet></Outlet>
        </div>
      </div>
    </div>
  )
}
